<div class="col-xs-12 col-md-2 col-lg-1 menu-items-strip">
  <div class="col-xs-3 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-borrower-dashboard{{dashboardClass}}" [routerLink]="dashboardLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">My Loans</div>
  </div>
  <div class="col-xs-3 col-md-12 menu-item-wrapper" *ngIf="!kycSuccess">
    <div class="menu-item finzy-borrower-passbook" (click)="blockPassbook()"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Passbook</div>
  </div>
  <div class="col-xs-3 col-md-12 menu-item-wrapper" *ngIf="kycSuccess">
    <div class="menu-item finzy-borrower-passbook{{passbookClass}}" [routerLink]="passbookLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Passbook</div>
  </div>
  <div class="col-xs-3 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-borrower-documents{{documentsClass}}" [routerLink]="documentsLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Documents</div>
  </div>
</div>
